import React from 'react';
import { useAuth } from '../Context/auth'; // 1. Importar o useAuth
import MenuLateral from '../Components/MenuPrincipal/MenuLateral';
import './minhaConta.css';

function MinhaConta() {
    // 2. Usar o hook useAuth para pegar os dados do usuário logado
    const { appUserData } = useAuth();

    // 3. Função para "traduzir" o status numérico para texto (ajustada para tenant_status)
    const decodificarStatus = (statusNumero) => {
        switch (statusNumero) {
            case 1: return 'Ativo';    // Assumindo 1 = Ativo
            case 2: return 'Em teste'; // Assumindo 2 = Em teste/Pendente
            case 3: return 'Vencido';  // Assumindo 3 = Vencido (se existir)
            case 4: return 'Inativo';  // Assumindo 4 = Inativo (se existir)
            default: return 'Desconhecido';
        }
    };

    // 4. Função para formatar a data (mantida, pois appUserData.data_vencimento é string)
    const formatarData = (dateString) => {
        if (!dateString) return 'N/A';
        try {
            const data = new Date(dateString);
            // Ajuste para garantir que a data seja interpretada corretamente
            // Adiciona algumas horas para compensar possíveis problemas de fuso no parse
            data.setUTCHours(12, 0, 0, 0);
            return data.toLocaleDateString('pt-BR');
        } catch (error) {
            return 'Data inválida';
        }
    };

    // 5. Função para retornar a classe CSS baseada no status (mantida)
    const getStatusClass = (statusTexto) => {
        switch (statusTexto) {
            case 'Em teste': return 'status-teste';
            case 'Ativo': return 'status-ativo';
            case 'Vencido':
            case 'Inativo': return 'status-inativo';
            default: return '';
        }
    };

    // Função para formatar o valor monetário
    const formatarValor = (valor) => {
        if (!valor || valor === 0) return 'Sob consulta';
        return `R$ ${parseFloat(valor).toFixed(2).replace('.', ',')}`;
    };

    // Link do WhatsApp (mantido)
    const numeroWhatsapp = "5537999826905";
    const mensagemRenovar = "Gostaria de renovar minha assinatura";
    const linkWhatsappRenovar = `https://wa.me/${numeroWhatsapp}?text=${encodeURIComponent(mensagemRenovar)}`;

    // 6. Renderiza carregamento se appUserData ainda não estiver disponível
    if (!appUserData) {
        return (
            <div style={{ display: 'flex', paddingTop: 0 }}>
                <MenuLateral />
                <div className="content-with-sidebar d-flex justify-content-center align-items-center" style={{ width: '100%', height: '100vh' }}>
                    <div className="text-center">
                        <div className="loading-spinner mb-3"></div>
                        <p>Carregando dados da conta...</p>
                    </div>
                </div>
            </div>
        );
    }

    // Nomes das variáveis para facilitar a leitura no JSX
    const statusTexto = decodificarStatus(appUserData.tenant_status);

    return (
        <div className="minha-conta-container" style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />

            <div className="content-with-sidebar">
                <div className="conta-header">
                    <h1 className="conta-title">Minha <span className="highlight">Conta</span></h1>
                </div>

                <div className="minha-conta-card">
                    <div className="card-header">
                        <h3>Status da Assinatura</h3>
                    </div>
                    <div className="card-body status-section">
                        <span className={`status-badge ${getStatusClass(statusTexto)}`}>
                            {statusTexto}
                        </span>
                        <p className="vencimento-info">
                            Sua assinatura vence em: <strong>{formatarData(appUserData.data_vencimento)}</strong>
                        </p>

                        <div className="mt-4 w-100 border-top pt-3">
                            <div className="row">
                                <div className="col-md-4 mb-2">
                                    <small className="text-muted d-block">Módulos Contratados</small>
                                    <strong className="fs-5 text-capitalize">
                                        {(appUserData?.modulos || []).map(m => {
                                            if (m === 1) return "Essencial";
                                            if (m === 2) return "Controle de Estoque";
                                            if (m === 3) return "Produção";
                                            return null;
                                        }).filter(Boolean).join(' + ') || 'Nenhum módulo ativo'}
                                    </strong>
                                </div>
                                <div className="col-md-4 mb-2">
                                    <small className="text-muted d-block">Licenças Ativas</small>
                                    <strong className="fs-5">{appUserData.max_sessions || 1} <span className="fs-6 fw-normal text-muted">usuários</span></strong>
                                </div>
                                <div className="col-md-4 mb-2">
                                    <small className="text-muted d-block">Valor Mensal</small>
                                    <strong className="fs-5 text-primary">{formatarValor(appUserData.valor)} / mês</strong>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card-header">
                        <h3>Dados Cadastrais</h3>
                    </div>
                    <div className="card-body">
                        <div className="info-grid">
                            <div className="info-item">
                                <div>
                                    <label>Nome / Razão Social</label>
                                    {/* 8. Usa appUserData.tenant_nome */}
                                    <span>{appUserData.tenant_nome}</span>
                                </div>
                            </div>
                            <div className="info-item">
                                <div>
                                    <label>CPF / CNPJ</label>
                                    {/* 9. Usa appUserData.cpf_cnpj */}
                                    <span>{appUserData.cpf_cnpj || 'Não disponível'}</span>
                                </div>
                            </div>
                            <div className="info-item">
                                <div>
                                    <label>Email de Login</label>
                                    {/* 10. Usa appUserData.email */}
                                    <span>{appUserData.email}</span>
                                </div>
                            </div>
                            <div className="info-item">
                                <div>
                                    <label>Telefone</label>
                                    {/* 11. Usa appUserData.telefone */}
                                    <span>{appUserData.telefone || 'Não disponível'}</span>
                                </div>
                            </div>
                            <div className="info-item info-item-full-width">
                                <div>
                                    <label>Endereço</label>
                                    {/* 12. Usa appUserData.cidade, uf, cep */}
                                    <span>{`${appUserData.cidade || ''} - ${appUserData.uf || ''}, CEP: ${appUserData.cep || ''}`}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card-footer">
                        <a href={linkWhatsappRenovar} target="_blank" rel="noopener noreferrer" className="btn btn-renovar">
                            Renovar Assinatura
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MinhaConta;